<section class="line-item-modal-container">
  <div class="modal-header">
    <h5 class="modal-title pull-left" style="font-weight: 600;">
      {{title}}
    </h5>
    <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
    </a>
  </div>
  <div class="modal-body">
    <div style="width: 90%; margin-left: 54px;">
      <ng-container *ngIf="selectedLineItems.length;else noData">
        <h6 style="font-weight: 600;">Schedule line item details</h6>
        <div class="table-responsive table-wrapper card">
          <table class="table table-striped mb-0 table-hover table-bordered" style="min-width:900px">
            <thead class="table-active">
              <tr>
                <th scope="col">Item No</th>
                <th scope="col">Delivery Counter</th>
                <th scope="col">PO Quantity</th>
                <th scope="col">Delivery Date Category</th>
                <th scope="col">Delivery Date </th>
                <th scope="col">Delivery Time</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="ScheduleItems">
                <tr *ngFor="let ScheduleItemsData of ScheduleItems">
                  <td>{{ ScheduleItemsData.po_id.line_item_no}}</td>
                  <td>{{ ScheduleItemsData.delivery_counter}}</td>
                  <td>{{ ScheduleItemsData.custom_po_quantity }}</td>
                  <td>{{ ScheduleItemsData.delivery_date_category}}</td>
                  <td>{{ ScheduleItemsData.start_delivery_date }}</td>
                  <td>{{ ScheduleItemsData.delivery_time | date:'mm:ss'}}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </ng-container>
      <ng-template #noData>
      </ng-template>
      <br>
      <!-- Line Item Drop down -->
      <ng-container>
        <select *ngIf="selectedLineItems && selectedLineItems.length && isSummary" [(ngModel)]="selectedLineItemNumber"
          (change)="onSelectLineItem($event)" [disabled]="!formIsValid" class="form-select form-select-sm col-md-3">
          <option disabled selected value="">Select Line Item</option>
          <option *ngFor="let option of selectedLineItems" [value]="option.line_item_detail.line_item_number">
            {{option.line_item_detail.line_item_number}}
          </option>
        </select>
        <select *ngIf="selectedLineItems && selectedLineItems.length && !isSummary" [(ngModel)]="selectedLineItemNumber"
          (change)="onSelectLineItem($event)" [disabled]="!formIsValid" class="form-select form-select-sm col-md-3">
          <option disabled selected value="">Select Line Item</option>
          <option *ngFor="let option of selectedLineItems" [value]="option.line_item_number">
            {{option.line_item_number}}
          </option>
        </select>
      </ng-container>
      <br><br>
      <form [formGroup]="POfieldsForm">
        <div class="d-flex">
          <h6>Select Type:</h6> &nbsp;&nbsp;
          <div class="form-check me-3">
            <input class="form-check-input" type="checkbox" id="flexCheckDefault" formControlName="fullSelection">
            <label class="form-check-label" for="flexCheckDefault">Full</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="flexCheckChecked" formControlName="partialSelection">
            <label class="form-check-label" for="flexCheckChecked">Partial</label>
          </div>
        </div>
        <br>
        <div *ngIf="POfieldsForm.get('fullSelection')?.value">
          <div class="row mb-2">
            <div class="col-3">
              <label for="conf-category"><sup style="color :red">*</sup>Confirmation category:</label><br>
              <select class="form-select form-select-sm" id="conf-category" formControlName="confCategory"
                [ngClass]="{'is-valid': POfieldsForm.get('confCategory')?.valid && POfieldsForm.get('confCategory')?.touched}"
                required>
                <option *ngFor="let category of dropdownList; let i = index" [value]="category.value">
                      {{category.description}} 
                  </option>
              </select>
              <div *ngIf="POfieldsForm.get('confCategory')?.touched && POfieldsForm.get('confCategory')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('confCategory')?.errors?.['required']">
                  Confirmation Category is required.
                </small>
              </div>
            </div>
            <div class="col-3">
              <label for="delivery-date-category">Deliver date category: </label><br>
              <select id="delivery-date-category" formControlName="deliveryDateCategory"
                class="form-select form-select-sm"
                [ngClass]="{'is-valid': POfieldsForm.get('deliveryDateCategory')?.valid && POfieldsForm.get('deliveryDateCategory')?.touched}"
                required>
                <option value="D">D</option>
                <!-- <option value="W">W</option>
                            <option value="T">T</option>
                            <option value="M">M</option> -->
              </select>
              <div
                *ngIf="POfieldsForm.get('deliveryDateCategory')?.touched && POfieldsForm.get('deliveryDateCategory')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('deliveryDateCategory')?.errors?.['required']">
                  Delivery Date is required.
                </small>
              </div>
            </div>
            <div class="col-3">
              <label for="created-date">Creation Date: </label><br>
              <input class="form-control form-control-sm" id="created-date" type="date" formControlName="createdDate"
                [ngClass]="{'is-valid': POfieldsForm.get('createdDate')?.valid && POfieldsForm.get('createdDate')?.touched}"
                readonly required>
              <div *ngIf="POfieldsForm.get('createdDate')?.touched && POfieldsForm.get('createdDate')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('createdDate')?.errors?.['required']">
                  Creation Date is required.
                </small>
              </div>
            </div>
            <div class="col-3">
              <label for="delivery-date">Delivery date: </label><br>
              <input class="form-control form-control-sm" id="delivery-date" type="date" formControlName="deliveryDate"
                [ngClass]="{'is-valid': POfieldsForm.get('deliveryDate')?.valid && POfieldsForm.get('deliveryDate')?.touched}"
                required>
              <div *ngIf="POfieldsForm.get('deliveryDate')?.touched && POfieldsForm.get('deliveryDate')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('deliveryDate')?.errors?.['required']">
                  Delivery Date is required.
                </small>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-3">
              <label for="po-number">PO Number: </label><br>
              <input class="form-control form-control-sm" id="po-number" type="number" formControlName="poNumber"
                [ngClass]="{'is-valid': POfieldsForm.get('poNumber')?.valid && POfieldsForm.get('poNumber')?.touched}"
                required>
              <div *ngIf="POfieldsForm.get('poNumber')?.touched && POfieldsForm.get('poNumber')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('poNumber')?.errors?.['required']">
                  PO Number is required.
                </small>
                <small class="text-danger" *ngIf="POfieldsForm.get('poNumber')?.errors?.['integer']">
                  PO Number must be an integer.
                </small>
              </div>
            </div>
            <div class="col-3">
              <label for="po-item-number">PO Item Number: </label><br>
              <input class="form-control form-control-sm" id="po-item-number" type="number"
                formControlName="poItemNumber"
                [ngClass]="{'is-valid': POfieldsForm.get('poItemNumber')?.valid && POfieldsForm.get('poItemNumber')?.touched}"
                required>
              <div *ngIf="POfieldsForm.get('poItemNumber')?.touched && POfieldsForm.get('poItemNumber')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('poItemNumber')?.errors?.['required']">
                  PO Item Number is required.
                </small>
                <small class="text-danger" *ngIf="POfieldsForm.get('poItemNumber')?.errors?.['integer']">
                  PO Item Number must be an integer.
                </small>
              </div>
            </div>
            <div class="col-3">
              <label for="quantity">Quantity: </label><br>
              <input class="form-control form-control-sm" id="quantity" type="number" formControlName="quantity"
                [ngClass]="{'is-valid': POfieldsForm.get('quantity')?.valid && POfieldsForm.get('quantity')?.touched}"
                readonly>
              <div *ngIf="POfieldsForm.get('quantity')?.touched && POfieldsForm.get('quantity')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('quantity')?.errors?.['required']">
                  Quantity is required.
                </small>
              </div>
            </div>
            <div class="col-3">
              <label for="reference"><sup style="color :red">*</sup>Reference: </label><br>
              <input class="form-control form-control-sm" id="reference" formControlName="reference"
                [ngClass]="{'is-valid': POfieldsForm.get('reference')?.valid && POfieldsForm.get('reference')?.touched}"
                required maxlength="35">
              <div *ngIf="POfieldsForm.get('reference')?.touched && POfieldsForm.get('reference')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('reference')?.errors?.['required']">
                  Reference is required.
                </small>
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-3">
              <label>Upload file</label>
              <input type="file" formControlName="uploadedfile" (change)="onFileChange($event)" />
            </div>
            <div class="col-3">
              <label for="remark"><sup style="color :red">*</sup>Remark: </label><br>
              <textarea class="form-control form-control-sm" id="remark" formControlName="remark"
                [ngClass]="{'is-valid': POfieldsForm.get('remark')?.valid && POfieldsForm.get('remark')?.touched}"
                required></textarea>
              <div *ngIf="POfieldsForm.get('remark')?.touched && POfieldsForm.get('remark')?.invalid">
                <small class="text-danger" *ngIf="POfieldsForm.get('remark')?.errors?.['required']">
                  Remark is required.
                </small>
              </div>
            </div>
          </div>
          <div *ngIf="attachment.length > 0">
            <hr class="my-2">
            <h4 class="text-normal"><strong>Attachments</strong></h4>
            <div class="row">
              <div class="col-md-3 my-42 m-2 upload-view" *ngFor="let file of attachment;let i=index;">
                <div>
                  <p class='mb-1'>
                    {{file.name}}
                  </p>
                </div>
                <div class='align-self-center'>
                  <a class='text-primary pointer' (click)="clearFile(i)">
                    <span class="fa fa-trash fa-2x"></span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="POfieldsForm.get('partialSelection')?.value" class="table-container">
          <div class="row align-items-center">
            <div class="col-10">
              <span class="quantity">Total Quantity: {{ poquantity }}</span>
              <span class="quantity">Available Quantity: {{ availableQuantity }}</span>
              <p style="color:red; margin-bottom: 0;" *ngIf="availableQuantity > 0">
                *Important Note: Ensure you enter all available quantities into the table.
              </p>
            </div>
            <div class="col-2 text-end">
              <button class="btn btn-primary text-white mx-2 mb-1" (click)="addRow()" [disabled]="isAddRowDisabled()">
                Add row
              </button>
            </div>
          </div>

          <div formArrayName="poItems"> <!-- This is where you use formArrayName -->
            <table class="table" style="font-size: 10px; border: 1px solid rgb(152, 152, 152); display: grid;">
              <thead>
                <tr>
                  <th style="width:10px">#</th>
                  <th style="padding-left:46px">Quantity</th>
                  <th style="padding-left: 59px;">Delivery date category</th>
                  <th style="padding-left: 52px;">Confirmation Category</th>
                  <th style="padding-left:111px">Creation Date</th>
                  <th style="padding-left:100px">Delivery Date</th>
                  <th style="padding-left:148px">Reference</th>
                  <th style="padding-left:114px">PO Number</th>
                  <th style="padding-left:122px">PO Item Number</th>
                  <th style="padding-left:96px">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of poItems.controls; let i = index" [formGroupName]="i">
                  <td style="width:35px;padding-top: 28px;">{{ i + 1 }}</td>
                  <td style="width:146px">
                    <input class="form-control form-control-sm" id="quantity" type="number" formControlName="quantity"
                      required>
                    <span *ngIf="availableQuantity < 0" style="color:red; font-size: 12px;">
                      Entered quantity exceeds the total quantity.
                    </span>
                  </td>
                  <td style="width: 85px;">
                    <select id="delivery-date-category" formControlName="deliveryDateCategory"
                      class="form-select form-select-sm" required>
                      <option value="D">D</option>
                      <!-- Other options can be uncommented as needed -->
                    </select>
                  </td>
                  <td style="width: 193px;">
                    <select class="form-select form-select-sm" id="conf-category" formControlName="confCategory"
                      required>
                      <option *ngFor="let category of dropdownList; let i = index" [value]="category.value">
                      {{category.description}} 
                  </option>
                    </select>
                  </td>
                  <td style="width:110px">
                    <input class="form-control form-control-sm" id="created-date" type="date"
                      formControlName="createdDate" required>
                  </td>
                  <td>
                    <input class="form-control form-control-sm" id="delivery-date" type="date"
                      formControlName="deliveryDate" required>
                  </td>
                  <td style="width: 176px">
                    <input class="form-control form-control-sm" id="reference" formControlName="reference" required
                      maxlength="35">
                  </td>
                  <td>
                    <input class="form-control form-control-sm" id="po-number" type="number" formControlName="poNumber"
                      readonly>
                  </td>
                  <td>
                    <input class="form-control form-control-sm" id="po-item-number" type="number"
                      formControlName="poItemNumber" readonly>
                  </td>
                  <td>
                    <input class="form-control form-control-sm" id="po-remark" type="text"
                      formControlName="remark">
                  </td>
                  <td style="width:38px;padding-top: 27px">
                    <input type="file" #fileInput style="display: none;" (change)="onFileChangePartial($event, i)">

                    <i class="fa fa-paperclip" (click)="triggerFileInput(fileInput)"></i>
                    <i class="fa fa-trash mr-1" style="margin-left: 3px" (click)="deleteRow(i)"></i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </form>

    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</button>
    <button class="btn btn-primary text-white mx-2" (click)="confirmPO()" [disabled]="!formIsValid">Confirm PO</button>
  </div>
</section>